import AppHeader from 'Components/AppHeader';
import { OneColLayoutProp } from './types';
import * as Styled from './styles';

const OneColLayout = ({ children }: OneColLayoutProp): JSX.Element => (
  <>
    <AppHeader />
    <Styled.Container>{children}</Styled.Container>
  </>
);

export default OneColLayout;
